<div class="section-sidebar">
  @if (config().dates === 'plannedAndExecuted' && config().plannedDateKey) {
    <gc-date-picker
      [inputLabel]="config().plannedDateKey! | translate"
      [placeholder]="'datepickerPlaceholder' | translate"
      [dateFormat]="dateFormat"
      [dateValue]="sectionState().plannedDate"
      [icon]="'calendar'"
      (dateSelected)="plannedDateChanged.emit($event)"
    />
  }

  <gc-date-picker
    [inputLabel]="config().executedDateKey | translate"
    [placeholder]="'datepickerPlaceholder' | translate"
    [dateFormat]="dateFormat"
    [dateValue]="sectionState().completedDate"
    [icon]="'calendar'"
    (dateSelected)="completedDateChanged.emit($event)"
  />

  @if (config().imageChecklist.length && config().id !== 'COMMISSION') {
    <gc-accordion [expanded]="true">
      <ng-template #gcAccordionHeader>
        <gc-text [variant]="'paragraphBold'">{{
          'installationReportV2.imageChecklist.title' | translate
        }}</gc-text>
      </ng-template>
      <ng-template #gcAccordionBody>
        <div class="checklist">
          @for (item of config().imageChecklist; track item.field) {
            <gc-checkbox
              [label]="item.labelKey | translate"
              [checked]="!!sectionState().imageChecklist[item.field]"
              (changed)="
                checklistChanged.emit({ field: item.field, checked: $event })
              "
            />
          }
        </div>
      </ng-template>
    </gc-accordion>
  }

  @if (config().hasFileUpload && config().id !== 'COMMISSION') {
    <gc-accordion [expanded]="true">
      <ng-template #gcAccordionHeader>
        <gc-text [variant]="'paragraphBold'">{{
          'installationReportV2.splicingAndMeasuringTab.fileAndImageUpload'
            | translate
        }}</gc-text>
      </ng-template>
      <ng-template #gcAccordionBody>
        <gc-filechooser
          [buttonLabel]="
            'installationReportV2.splicingAndMeasuringTab.upload' | translate
          "
          [multiple]="true"
          [variant]="'strong'"
          [icon]="'upload'"
          [iconPosition]="'left'"
          (fileChanged)="filesChanged.emit($event)"
        />
      </ng-template>
    </gc-accordion>
  }

  @if (config().hasComment) {
    <gc-input-field
      [label]="'buildingPageModal.comment' | translate"
      [value]="sectionState().comment"
      [renderTextArea]="true"
      [placeholder]="'buildingPageModal.commentPlaceholderPhase' | translate"
      [rows]="4"
      (changed)="commentChanged.emit($event)"
    />
  }

  @if (canMarkNotApplicable()) {
    <gc-button
      [variant]="'secondary'"
      [icon]="'triangleExclamation'"
      (clicked)="markNotApplicableClicked.emit()"
    >
      {{
        'buildingPageModal.sectionNotApplicable.markAsNotApplicable' | translate
      }}
    </gc-button>
  }
</div>
